import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import useRequireAuth from '../../hooks/useRequireAuth';

const TABS = [
  { to: '/', label: '主頁', end: true, auth: false },
  { to: '/market', label: '行情', end: false, auth: false },
  { to: '/trade/futures', label: '交易', end: false, auth: false },
  { to: '/orders', label: '訂單', end: false, auth: true },
  { to: '/wallet', label: '資金', end: false, auth: true },
];

export default function BottomNav() {
  const { isAuthenticated } = useAuth();
  const requireAuth = useRequireAuth();
  const location = useLocation();

  return (
    <nav className="bottom-nav" aria-label="主導覽">
      {TABS.map((tab) => {
        const isActive = tab.end
          ? location.pathname === tab.to
          : location.pathname.startsWith(tab.to);

        if (tab.auth && !isAuthenticated) {
          return (
            <button
              key={tab.to}
              type="button"
              className={`bottom-nav__item ${isActive ? 'is-active' : ''}`}
              onClick={() => requireAuth(tab.to)}
            >
              <BottomNavIcon type={tab.label} />
              <span>{tab.label}</span>
            </button>
          );
        }

        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={`bottom-nav__item ${isActive ? 'is-active' : ''}`}
          >
            <BottomNavIcon type={tab.label} />
            <span>{tab.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}

function BottomNavIcon({ type }) {
  const icons = {
    主頁: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M4 10.5L12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-6H10v6H5a1 1 0 0 1-1-1v-9.5z"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinejoin="round"
        />
      </svg>
    ),
    行情: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M4 18V6M10 18V10M16 18V8M22 18V4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    交易: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M8 7l4-4 4 4M12 3v12M8 17l4 4 4-4M12 21V9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    訂單: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M7 4h10v16H7zM9 8h6M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
    資金: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M4 7h16v10H4zM16 11a2 2 0 1 1 0 .01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    ),
  };
  return icons[type] || null;
}
